import React from 'react';
import {Box} from '@mui/material';
import {
  Button,
  designSystemToken,
  Icon,
  Tooltip,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

interface ReplaceVideoButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

function ReplaceVideoButton({onClick}: ReplaceVideoButtonProps) {
  return (
    <Tooltip title={translate('Replace Video')} placement="top" arrow>
      <Box>
        <Button
          appearance="neutral"
          mode="tinted"
          size="medium"
          sx={{padding: '6px 8px'}}
          onClick={onClick}
        >
          <Icon
            name="Actions-Reset"
            appearance="neutral"
            size="medium"
            color={designSystemToken('semantic.fg.neutral')}
          />
        </Button>
      </Box>
    </Tooltip>
  );
}

export default ReplaceVideoButton;
